/*
I took this from https://github.com/spirosikmd/angular2-elastic-input. The reason
I made a copy is because I wanted to also take into account the placeholder text.
*/
import {
    ElementRef,
    HostListener,
    Directive,
    OnInit,
    AfterContentChecked,
    OnDestroy
} from '@angular/core';

@Directive({
    selector: 'input[elastic-input]',
    standalone: false
})
export class ElasticInputDirective
    implements OnInit, AfterContentChecked, OnDestroy
{
    wrapper: HTMLElement;
    mirror: HTMLElement;

    @HostListener('input', ['$event.target'])
    onInput(): void {
        this.update();
    }

    constructor(private element: ElementRef) {}

    ngOnInit(): void {
        this.wrapper = document.createElement('div');
        this.wrapper.style.position = 'fixed';
        this.wrapper.style.top = '-999px';
        this.wrapper.style.left = '0';
        document.body.appendChild(this.wrapper);

        this.mirror = document.createElement('span');
        this.mirror.style.whiteSpace = 'pre';

        this.setMirrorStyle(this.mirror, this.element.nativeElement);

        this.wrapper.appendChild(this.mirror);

        this.update();
    }

    ngAfterContentChecked(): void {
        this.update();
    }

    ngOnDestroy(): void {
        this.mirror.remove();
        this.wrapper.remove();
    }

    setMirrorStyle(mirror: HTMLElement, element: HTMLElement) {
        const style = window.getComputedStyle(element);
        [
            'fontFamily',
            'fontSize',
            'fontWeight',
            'fontStyle',
            'letterSpacing',
            'textTransform',
            'wordSpacing'
        ].forEach((value: any) => {
            mirror.style[value] = style[value];
        });
        mirror.style.paddingLeft = style.textIndent;

        // TODO: Are we ever not using border-box?
        if (style.boxSizing === 'border-box') {
            [
                'paddingLeft',
                'paddingRight',
                'borderLeftStyle',
                'borderLeftWidth',
                'borderRightStyle',
                'borderRightWidth'
            ].forEach((value: any) => {
                mirror.style[value] = style[value];
            });
        } else if (style.boxSizing === 'padding-box') {
            ['paddingLeft', 'paddingRight'].forEach((value: any) => {
                mirror.style[value] = style[value];
            });
        }
    }

    update() {
        this.mirror.innerText = this.element.nativeElement.value;
        let width = this.mirror.offsetWidth;
        const placeholder =
            this.element.nativeElement.getAttribute('placeholder');
        if (placeholder) {
            this.mirror.innerText = placeholder;
            width =
                this.mirror.offsetWidth < width
                    ? width
                    : this.mirror.offsetWidth;
        }
        const delta = 1;
        this.element.nativeElement.style.width = `${width + delta}px`;
    }
}
